import classNames from 'classnames';
import { getAccessHint } from '@utils/dataShare';
import { getViewAccess } from '../utils';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { InitiativeCompany } from '@g17eco/types/initiativeSurvey';


interface AccessStatusProps {
  company: InitiativeCompany;
}
const AccessStatus = ({ company }: AccessStatusProps) => {
  return (
    <SimpleTooltip text={getAccessHint(company)}>
      <div className={classNames('access-status', getViewAccess(company))} />
    </SimpleTooltip>
  );
};

export default AccessStatus;
